webpackJsonp([114276838955818,60335399758886],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(105);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(293);
	var isArguments = __webpack_require__(292);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(432);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(291);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(414);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(300));
	var shallowEqual = _interopDefault(__webpack_require__(449));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","brand":"src-components-Footer----footer-module---brand---1NGB8","links":"src-components-Footer----footer-module---links---EXm1s"};

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footerModule = __webpack_require__(301);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _logoRed = __webpack_require__(452);
	
	var _logoRed2 = _interopRequireDefault(_logoRed);
	
	var _mail = __webpack_require__(453);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _pencil = __webpack_require__(454);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _twitter = __webpack_require__(455);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _github = __webpack_require__(451);
	
	var _github2 = _interopRequireDefault(_github);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: _footerModule2.default.footer },
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.brand },
	      _react2.default.createElement('img', { src: _logoRed2.default }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', className: _footerModule2.default.link },
	        ' Dapis'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' Created by ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.ramonrecuero.com', target: '_blank' },
	          'Ram\xF3n Recuero'
	        ),
	        ' '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.links },
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:ramon@dapis.io', target: '_blank' },
	        _react2.default.createElement('img', { src: _mail2.default })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://medium.com/@rrecuero/building-dapps-people-want-d133e8904b8', target: '_blank' },
	        _react2.default.createElement('img', { src: _pencil2.default })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/ramonrecuero', target: '_blank' },
	        _react2.default.createElement('img', { src: _twitter2.default })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/rrecuero', target: '_blank' },
	        _react2.default.createElement('img', { src: _github2.default })
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjJweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjIgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iRGFwaXMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJkYXBpcy1vcHRpb24tMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMjkuMDAwMDAwLCAtMzg3MS4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIyNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE1LjAwMDAwMCwgMzg1MC45ODAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05MzQuNTYyNSwyNS45MDE1IEw5MzMuNDgzNSwyNi45ODA1IEw5MjkuMTY2NSwyMi42NjM1IEw5MzAuMjQ5NSwyMS41Nzk1IEM5MzEuNDM5NSwyMC4zODY1IDkzMy4zNzE1LDIwLjM4NjUgOTM0LjU2MjUsMjEuNTc5NSBDOTM1Ljc1MjUsMjIuNzczNSA5MzUuNzUyNSwyNC43MDg1IDkzNC41NjI1LDI1LjkwMTUgWiBNOTIxLjIzMDUsMzkuMjQ1NSBDOTIxLjE2NjUsMzkuMzA4NSA5MjEuMDg2NSwzOS4zNzQ1IDkyMS4wMDI1LDM5LjQzOTUgQzkyMC45NTQ1LDM4LjY4NTUgOTIwLjYzNjUsMzcuOTQ2NSA5MjAuMDQzNSwzNy4zNzA1IEw5MTkuOTUwNSwzNy4yNzg1IEw5MTguODcxNSwzNi4yMzA1IEw5MTguODcwNSwzNi4yMjg1IEw5MTguNDcxNSwzNS44NDA1IEM5MTguMDEyNSwzNS4zOTQ1IDkxNy40NTM1LDM1LjExNDUgOTE2Ljg2NjUsMzQuOTg0NSBDOTE2Ljg4MjUsMzQuOTY2NSA5MTYuODk5NSwzNC45NDI1IDkxNi45MTY1LDM0LjkyNTUgTDkyOC4xMDg1LDIzLjcyNDUgTDkyOS42ODE1LDI1LjI5ODUgTDkzMC44MDQ1LDI2LjQyMzUgTDkzMi40MjM1LDI4LjA0MzUgTDkyMS4yMzA1LDM5LjI0NTUgWiBNOTE0LjU3NDUsNDEuNTkwNSBDOTE0LjIyMjUsNDEuMjQwNSA5MTUuMDg0NSwzOC4yMjI1IDkxNi4wNDE1LDM2LjI4OTUgQzkxNi43MTY1LDM2LjQ2MzUgOTE3LjM2NTUsMzYuNzkyNSA5MTcuODk5NSwzNy4zMTM1IEw5MTguNTI5NSwzNy45MjQ1IEM5MTkuMTkxNSwzOC41Njk1IDkxOS41ODE1LDM5LjM3NTUgOTE5LjY5NzUsNDAuMjAwNSBDOTE3Ljc1OTUsNDEuMTE5NSA5MTQuODk1NSw0MS45MTU1IDkxNC41NzQ1LDQxLjU5MDUgWiIgaWQ9IkZpbGwtMjEzIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"src-components-Header----header-module---header---1a1MQ","brand":"src-components-Header----header-module---brand---QmEpm"};

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerModule = __webpack_require__(302);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _logoRed = __webpack_require__(456);
	
	var _logoRed2 = _interopRequireDefault(_logoRed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.header },
	    _react2.default.createElement(
	      'nav',
	      { id: 'menu', className: 'menu' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          { className: _headerModule2.default.brand },
	          _react2.default.createElement('img', { src: _logoRed2.default }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#menu', className: _headerModule2.default.link },
	            ' Dapis'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#fullstack', className: _headerModule2.default.link },
	            ' Full Stack Template'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#dblog', className: _headerModule2.default.link },
	            ' dBlog'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '#proof', className: _headerModule2.default.link },
	            ' Project Proof'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(413);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(346);
	
	var _Header = __webpack_require__(202);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(201);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: 'Dapis',
	        meta: [{ name: 'description', content: 'Dapis.io' }, { name: 'keywords', content: 'dapis.io, web3, saas, dapis, decentralized api' }]
	      },
	      _react2.default.createElement('link', { href: 'https://fastcdn.org/Animate.css/3.4.0/animate.min.css', rel: 'stylesheet' }),
	      _react2.default.createElement('script', { src: 'https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js', type: 'text/javascript' }),
	      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://use.fontawesome.com/releases/v5.5.0/css/all.css', integrity: 'sha384-B4dIYHKNBt8Bc12p+WXckhzcICo0wtJAoU8YZTY5qE0Id1GSseTk6S+L3BlXeVIU', crossorigin: 'anonymous' }),
	      _react2.default.createElement(
	        'script',
	        { type: 'text/javascript' },
	        '\n      window.productHuntUpcoming = {\n        appId: 8283,\n        position: \'bottomLeft\',\n      };\n\n      (function(doc, scr, src, a, b) {\n        a = doc.createElement(scr);\n        b = doc.getElementsByTagName(scr)[0];\n        a.async = true;\n        a.src = src;\n        b.parentNode.insertBefore(a, b);\n      })(document, \'script\', \'https://assets.producthunt.com/assets/upwigloader.js\');\n  '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'main' },
	      _react2.default.createElement(_Header2.default, null),
	      children(),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-fc25350f4d039c4d09bc.js